import {useMemo} from 'react';
import {useQuery} from 'react-query';
import {fetchRuleListAssociation} from '../../../../../requests/queries/flows';

export const useRuleLists = ({ruleId, value, conditionId}) => {
  const {
    data: ruleLists,
    isLoading,
    isFetching,
  } = useQuery(['ruleLists', ruleId], () => fetchRuleListAssociation(ruleId), {
    enabled: Array.isArray(value),
  });

  const currentList = useMemo(
    () =>
      Array.isArray(ruleLists?.associations[0]?.list) &&
      ruleLists?.associations[0]?.list?.find(
        item => item?.condition === conditionId,
      ),
    [conditionId, ruleLists?.associations],
  );
  return {
    currentList,
    ruleListsLoading: isLoading || isFetching,
    ruleLists: ruleLists?.associations[0]?.list || [],
  };
};
